window.searchType = null;
var tabs;

window.tagManager = function (payload) {
  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "search_attempt",
    query: payload.value,
    section: payload.type,
  });
};

function updateValue(e) {
  var obj = { value: e.target.value, type: searchType };

  tagManager(obj);
}

// document is ready when run code
document.addEventListener("DOMContentLoaded", function () {
  var elements = document.querySelectorAll(".js-booking-section");

  if (elements.length) {
    if (elements.length > 1) {
      searchType = document
        .querySelector(".js-booking-section.active")
        .getAttribute("data-searchtype");
    } else {
      searchType = elements[0].getAttribute("data-searchtype");
    }

    var inputs = document.querySelectorAll(".js-booking-section input");

    var timer,
      delay = 500;

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener("input", function (e) {
        clearTimeout(timer);

        timer = setTimeout(function () {
          updateValue(e);
        }, delay);
      });
    }

    var tabsButton = document.querySelectorAll(
      ".js-tab-nav .js-tab-nav-header *"
    );

    for (var i = 0; i < tabsButton.length; i++) {
      tabsButton[i].addEventListener("click", function (e) {
        searchType = ser = document
          .querySelector(".js-booking-section.active")
          .getAttribute("data-searchtype");
      });
    }
  }
});
